import React from "react"
import { graphql, useStaticQuery } from "gatsby"

import CountyTemplate from "../templates/county.template"

const IndexPage = () => {
  let data = useStaticQuery(graphql`
    query loadIndexQuery {
      contentfulCountyPage(countyName: { eq: "Stafford" }) {
        countyName
        call
        text
        email
        map {
          map
        }
        reviewLink
        mainText {
          json
        }
        reviewText {
          json
        }
        imageCarousel {
          images {
            title
            description
            fluid(quality: 100, resizingBehavior: FILL) {
              src
              sizes
            }
          }
        }
      }
    }
  `)
  return <CountyTemplate pageContext={data.contentfulCountyPage} />
}

export default IndexPage
